/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { AnyAction } from 'redux'

const actions = {
  LOAD_COLLECTION: 'content-collections/LOAD_COLLECTION',
  SET_STATE: 'content-collections/SET_STATE',
  LOAD_STATE: 'content-collections/LOAD_STATE',
  UPLOAD_ITEM: 'content-collections/UPLOAD_ITEM',
  GET_STATE: 'content-collections/GET_STATE',
}
export default actions

export const setLoading = (loading: boolean): AnyAction => {
  return {
    type: actions.SET_STATE,
    payload: {
      loading,
    },
  }
}

export const loadCollection = (parentId: string, page: number, query: string): AnyAction => {
  return {
    type: actions.LOAD_COLLECTION,
    payload: {
      parentId,
      page,
      query,
    },
  }
}

export const setState = (payload: any): AnyAction => {
  return {
    type: actions.SET_STATE,
    payload,
  }
}

export const uploadItem = (contentItemId: string): AnyAction => {
  return {
    type: actions.UPLOAD_ITEM,
    payload: {
      contentItemId,
    },
  }
}
